<template>
  <div class="chapters-page">
    <h1 class="page-title">PERKI Chapters</h1>
    <div class="chapters-grid">
      <div v-for="chapter in chapters" :key="chapter.id" class="chapter-card">
        <div class="card-icon">
          <img :src="locationIcon" alt="Location Pin" />
        </div>
        <h3 class="card-title">{{ chapter.name }}</h3>
        <p class="card-text" v-if="chapter.address">
          <strong>Sekretariat:</strong> {{ chapter.address }}
        </p>
        <p class="card-text" v-if="chapter.contact">
          <strong>Contact:</strong> {{ chapter.contact }}
        </p>
        <p class="card-text" v-if="chapter.email"><strong>Email:</strong> {{ chapter.email }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// CATATAN: Ganti ini dengan path yang benar ke icon pin Anda
import locationIcon from '@/assets/img/about-us/who-we-are/section-1.png'

export default {
  name: 'Chapters',
  data() {
    return {
      locationIcon, // Icon untuk ditampilkan di setiap card
      chapters: [
        {
          id: 1,
          name: 'PERKI Aceh',
          address: 'RSUD dr. Zainoel Abidin, Jl. T. Daud Beureueh No. 108, Banda Aceh',
          contact: '08116891008',
          email: 'perkiaceh@gmail.com',
        },
        {
          id: 2,
          name: 'PERKI Sumatera Utara',
          address:
            'RSUP H. Adam Malik, Jl. Bunga Lau No. 17, Kemenangan Tani, Medan Tuntungan, Medan 20136',
          contact: '061-8361721',
          email: 'perkisumut@gmail.com',
        },
        {
          id: 3,
          name: 'PERKI Sumatera Barat',
          address: 'RSUP Dr. M. Djamil, Jl. Perintis Kemerdekaan, Padang 25127',
          contact: '0751-32372',
          email: 'perkisumbar@gmail.com',
        },
        {
          id: 4,
          name: 'PERKI Pekan Baru',
          address: 'RSUD Arifin Achmad, Jl. Diponegoro No. 2, Pekanbaru 28111',
          contact: '0761-21618',
          email: 'perkipekanbaru@gmail.com',
        },
        {
          id: 5,
          name: 'PERKI Jambi',
          address: 'RSUD Raden Mattaher, Jl. Letjend Soeprapto No. 31, Jambi',
          contact: '0741-61692',
          email: 'perkijambi@gmail.com',
        },
        {
          id: 6,
          name: 'PERKI Batam',
          address: 'RS Otorita Batam, Jl. Dr. Cipto Mangunkusumo, Sei Ladi, Batam',
          contact: '0778-459123',
          email: 'perkibatam@gmail.com',
        },
        {
          id: 7,
          name: 'PERKI Bengkulu',
          address: 'RSUD M. Yunus, Jl. Bhayangkara, Sidomulyo, Bengkulu',
          contact: '0736-21710',
          email: 'perkibengkulu@gmail.com',
        },
        {
          id: 8,
          name: 'PERKI Palembang',
          address: 'RSUP Dr. Moh. Hoesin, Jl. Jend. Sudirman Km 3.5, Palembang',
          contact: '0711-354088',
          email: 'perkipalembang@gmail.com',
        },
        {
          id: 9,
          name: 'PERKI Lampung',
          address: 'RSUD Dr. H. Abdul Moeloek, Jl. Dr. Rivai No. 6, Bandar Lampung',
          contact: '0721-702460',
          email: 'perkilampung@gmail.com',
        },
        {
          id: 10,
          name: 'PERKI Banten',
          address: 'RS Jantung Diagram, Jl. Cinere Raya No. 19, Cinere, Depok',
          contact: '021-7545599',
          email: 'perkibanten@gmail.com',
        },
        {
          id: 11,
          name: 'PERKI Jakarta',
          address:
            'RS Jantung dan Pembuluh Darah Harapan Kita, Jl. Letjend S. Parman Kav. 87, Jakarta 11420',
          contact: '021-5684093',
          email: 'perkijaya@gmail.com',
        },
        {
          id: 12,
          name: 'PERKI Bekasi',
          address:
            'RS Mitra Keluarga Bekasi Timur, Jl. Pengasinan Raya No. 3, Rawa Semut, Margahayu, Bekasi',
          contact: '021-8817799',
          email: 'perkibekasi@gmail.com',
        },
        {
          id: 13,
          name: 'PERKI Bogor',
          address: 'RSUD Ciawi, Jl. Raya Puncak No. 479, Ciawi, Bogor',
          contact: '0251-8240774',
          email: 'perkibogor@gmail.com',
        },
        {
          id: 14,
          name: 'PERKI Bandung',
          address: 'RSUP Dr. Hasan Sadikin, Jl. Pasteur No. 38, Bandung 40161',
          contact: '022-2038988',
          email: 'perkibandung@gmail.com',
        },
        {
          id: 15,
          name: 'PERKI Cirebon',
          address: 'RSUD Gunung Jati, Jl. Ks. Tubun No. 100, Cirebon 45125',
          contact: '0231-206330',
          email: 'perkicirebon@gmail.com',
        },
        {
          id: 16,
          name: 'PERKI Tasik',
          address: 'RSUD Dr. Soekardjo, Jl. Rumah Sakit No. 33, Tasikmalaya',
          contact: '0265-331683',
          email: 'perkitasikmalaya@gmail.com',
        },
        {
          id: 17,
          name: 'PERKI Pekalongan',
          address: 'RSUD Bendan, Jl. Sriwijaya No. 2, Pekalongan',
          contact: '0285-423308',
          email: 'perkipekalongan@gmail.com',
        },
        {
          id: 18,
          name: 'PERKI Purwokerto',
          address: 'RSUD Prof. Dr. Margono Soekarjo, Jl. Dr. Angka No. 1, Purwokerto',
          contact: '',
          email: 'perkipurwokerto@gmail.com',
        },
        {
          id: 19,
          name: 'PERKI Tegal',
          address: 'RSUD Kardinah, Jl. KS. Tubun No. 2, Tegal 52124',
          contact: '0283-351031',
          email: 'perkitegal@gmail.com',
        },
        {
          id: 20,
          name: 'PERKI Pekalongan',
          address: 'RSUD Bendan, Jl. Sriwijaya No. 2, Pekalongan',
          contact: '0285-423308',
          email: 'perkipekalongan@gmail.com',
        },
        {
          id: 21,
          name: 'PERKI Purwokerto',
          address: 'RSUD Prof. Dr. Margono Soekarjo, Jl. Dr. Angka No. 1, Purwokerto',
          contact: '',
          email: 'perkipurwokerto@gmail.com',
        },
        {
          id: 22,
          name: 'PERKI Solo',
          address: 'RSUD Dr. Moewardi, Jl. Kol. Sutarto No. 132, Surakarta',
          contact: '0271-634634',
          email: 'perkisolo@gmail.com',
        },
        {
          id: 23,
          name: 'PERKI Yogyakarta',
          address: 'RSUP Dr. Sardjito, Jl. Kesehatan No. 1, Yogyakarta 55284',
          contact: '0274-587333',
          email: 'perkijogja@gmail.com',
        },
        {
          id: 24,
          name: 'PERKI Semarang',
          address: 'RSUP Dr. Kariadi, Jl. Dr. Soetomo No. 16, Semarang 50231',
          contact: '024-8413260',
          email: 'perkisemarang@gmail.com',
        },
        {
          id: 25,
          name: 'PERKI Surabaya',
          address: 'RSUD Dr. Soetomo, Jl. Mayjend Prof. Dr. Moestopo No. 6-8, Surabaya',
          contact: '031-5020081',
          email: 'perkisurabaya@gmail.com',
        },
        {
          id: 26,
          name: 'PERKI Malang',
          address: 'RSUD Dr. Saiful Anwar, Jl. Jaksa Agung Suprapto No. 2, Malang',
          contact: '0341-362101',
          email: 'perkimalang@gmail.com',
        },
        {
          id: 27,
          name: 'PERKI Pontianak',
          address: 'RSUD Dr. Soedarso, Jl. Dr. Soedarso No. 1, Pontianak',
          contact: '0561-737701',
          email: 'perkipontianak@gmail.com',
        },
        {
          id: 28,
          name: 'PERKI Banjarmasin',
          address: 'RSUD Ulin, Jl. A. Yani No. 43, Banjarmasin 70233',
          contact: '0511-3252229',
          email: 'perkibanjarmasin@gmail.com',
        },
        {
          id: 29,
          name: 'PERKI Banjarmasin',
          address: 'RSUD Ulin, Jl. A. Yani No. 43, Banjarmasin 70233',
          contact: '0511-3252229',
          email: 'perkibanjarmasin@gmail.com',
        },
        {
          id: 30,
          name: 'PERKI Samarinda',
          address: 'RSUD Abdul Wahab Sjahranie, Jl. Dr. Soetomo, Samarinda',
          contact: '0541-738118',
          email: 'perkisamarinda@gmail.com',
        },
        {
          id: 31,
          name: 'PERKI Bali',
          address: 'RSUP Sanglah, Jl. Diponegoro, Denpasar 80114',
          contact: '0361-227912',
          email: 'perkibali@gmail.com',
        },
        {
          id: 32,
          name: 'PERKI Makassar',
          address: 'RSUP Dr. Wahidin Sudirohusodo, Jl. Perintis Kemerdekaan Km. 11, Makassar',
          contact: '0411-584711',
          email: 'perkimakassar@gmail.com',
        },
        {
          id: 33,
          name: 'PERKI Palu',
          address: 'RSUD Anutapura, Jl. Kangkung No. 1, Palu, Sulawesi Tengah',
          contact: '0451-421190',
          email: 'perkipalu@gmail.com',
        },
        {
          id: 34,
          name: 'PERKI Gorontalo',
          address: 'RSUD Prof. Dr. H. Aloei Saboe, Jl. Prof. Dr. H. Aloei Saboe, Gorontalo',
          contact: '0435-827255',
          email: 'perkigorontalo@gmail.com',
        },
        {
          id: 35,
          name: 'PERKI Manado',
          address: 'RSUP Prof. Dr. R. D. Kandou, Jl. Raya Tanawangko, Manado',
          contact: '0431-821703',
          email: 'perkimanado@gmail.com',
        },
        {
          id: 36,
          name: 'PERKI NTB',
          address: 'RSUD Provinsi NTB, Jl. Prabu Rangkasari, Dasan Cermen, Mataram',
          contact: '0370-638686',
          email: 'perkintb@gmail.com',
        },
        {
          id: 37,
          name: 'PERKI NTT',
          address: 'RSUD Prof. Dr. W. Z. Johannes, Jl. Dr. Moch. Hatta No. 16, Kupang',
          contact: '0380-833613',
          email: 'perkintt@gmail.com',
        },
        {
          id: 38,
          name: 'PERKI Ambon',
          address: 'RSUD Dr. M. Haulussy, Jl. Dr. Kayadoe, Kudamati, Ambon',
          contact: '0911-343137',
          email: 'perkiambon@gmail.com',
        },
        {
          id: 39,
          name: 'PERKI Jayapura',
          address: 'RSUD Jayapura, Jl. Kesehatan No. 1, Dok II, Jayapura',
          contact: '0967-533616',
          email: 'perkijayapura@gmail.com',
        },
        {
          id: 40,
          name: 'PERKI Cilegon',
          address: 'RS Krakatau Medika, Jl. Semang Raya, Cilegon',
          contact: '0254-396111',
          email: 'perkicilegon@gmail.com',
        },
        {
          id: 41,
          name: 'PERKI Jember',
          address: 'RSUD Dr. Soebandi, Jl. Dr. Soebandi No. 124, Jember',
          contact: '0331-487441',
          email: 'perkijember@gmail.com',
        },
        {
          id: 42,
          name: 'PERKI Kalimantan',
          address: 'RSUD Dr. Soedarso, Jl. Dr. Soedarso No. 1, Pontianak',
          contact: '0561-737701',
          email: 'perkikalimantan@gmail.com',
        },
        {
          id: 43,
          name: 'PERKI Kendari',
          address: 'RSUD Bahteramas, Jl. Kapten Piere Tendean, Kendari',
          contact: '0401-3195611',
          email: 'perkikendari@gmail.com',
        },
        {
          id: 44,
          name: 'PERKI Maluku',
          address: 'RSUD Dr. M. Haulussy, Jl. Dr. Kayadoe, Kudamati, Ambon',
          contact: '0911-343137',
          email: 'perkimaluku@gmail.com',
        },
        {
          id: 45,
          name: 'PERKI Papua',
          address: 'RSUD Jayapura, Jl. Kesehatan No. 1, Dok II, Jayapura',
          contact: '0967-533616',
          email: 'perkipapua@gmail.com',
        },
      ],
    }
  },
}
</script>

<style scoped>
.chapters-page {
  padding: 3rem 2rem;
  font-family: 'Arial', sans-serif;
  background-color: #ffffff;
}

.page-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 3rem;
}

.chapters-grid {
  display: grid;
  /* Membuat 3 kolom yang sama lebar */
  grid-template-columns: repeat(3, 1fr);
  /* Jarak antar card */
  gap: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.chapter-card {
  background-color: #f8f9fa; /* Warna abu-abu muda seperti di gambar */
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.card-icon {
  margin-bottom: 1rem;
}

.card-icon img {
  width: 60px;
  height: 60px;
}

.card-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #e10f28;
  margin-bottom: 1.5rem;
  min-height: 40px;
}

.card-text {
  font-size: 0.9rem;
  color: #555;
  text-align: left;
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.card-text strong {
  color: #000;
  font-weight: 700;
  display: block; /* Membuat label (Sekretariat, Contact) di baris sendiri */
}

/* --- Media Queries untuk Responsif --- */

@media (max-width: 1200px) {
  .chapters-grid {
    /* 2 kolom untuk tablet */
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .chapters-page {
    padding: 2rem 1rem;
  }

  .chapters-grid {
    /* 1 kolom untuk mobile */
    grid-template-columns: 1fr;
  }

  .card-title {
    min-height: auto; /* Hapus tinggi minimum di mobile */
  }
}
</style>
